var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.491699 14.5696C0.491699 17.3802 2.78075 19.6665 5.59303 19.6665H14.3382C17.1505 19.6665 19.4396 17.3802 19.4396 14.5696V5.83188C19.4396 3.02123 17.1505 0.734863 14.3382 0.734863H5.59303C2.78075 0.734863 0.491699 3.02123 0.491699 5.83188V14.5696ZM15.4318 3.64781C16.0352 3.64781 16.525 4.13645 16.525 4.74016C16.525 5.34389 16.0352 5.83249 15.4318 5.83249C14.8282 5.83249 14.3384 5.34389 14.3384 4.74016C14.3384 4.13645 14.8282 3.64781 15.4318 3.64781ZM9.96577 15.2977C7.15348 15.2977 4.86443 13.0114 4.86443 10.2007C4.86443 7.39016 7.15348 5.1038 9.96577 5.1038C12.7781 5.1038 15.0671 7.39016 15.0671 10.2007C15.0671 13.0114 12.7781 15.2977 9.96577 15.2977Z",
    fill: "#0086D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e05b7e4170afbae79a7b98763e3bc703.svg";
export { ForwardRef as ReactComponent };